import React, { useState } from 'react';
import type { ToolUseBlock } from '../../store/chatStore';

import { useTranslation } from 'react-i18next';

interface ToolParameterViewProps {
  toolUse: ToolUseBlock;
}

export const ToolParameterView: React.FC<ToolParameterViewProps> = ({
  toolUse,
}) => {
  const { t } = useTranslation('pleri/chat');
  const [copied, setCopied] = useState(false);
  const source = (toolUse.meta as { source?: string })?.source;

  const handleCopy = () => {
    navigator.clipboard.writeText(JSON.stringify(toolUse.input, null, 2));
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="flex flex-col gap-3 p-5">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="text-xs font-semibold tracking-wider text-gray-400 uppercase dark:text-gray-500">
            {t('input')}
          </span>
          <span className="rounded-md bg-gray-100 px-2 py-0.5 font-mono text-xs text-gray-600 dark:bg-gray-800 dark:text-gray-400">
            {toolUse.name}
          </span>
          {source && (
            <span className="rounded-md bg-[#FF732E]/10 px-2 py-0.5 text-xs font-medium text-[#FF732E]">
              {source.charAt(0).toUpperCase() + source.slice(1)}
            </span>
          )}
        </div>
        <button
          onClick={handleCopy}
          className="text-xs text-gray-400 transition-colors hover:text-gray-600 dark:hover:text-gray-300"
        >
          {copied ? t('copied') : t('copy')}
        </button>
      </div>
      <pre className="overflow-x-auto rounded-lg bg-[#0d1117] p-4 font-mono text-xs leading-relaxed text-[#e6edf3]">
        {JSON.stringify(toolUse.input, null, 2)}
      </pre>
    </div>
  );
};
